import { render, staticRenderFns } from "./Buscaroportunidad.vue?vue&type=template&id=97881542&"
import script from "./Buscaroportunidad.vue?vue&type=script&lang=js&"
export * from "./Buscaroportunidad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports